import React from 'react'

import { AppRoutes, LayoutType, type RouteConfig } from '../routes.types'

// Team management components
const LazyTeamDirectoryPage = React.lazy(() =>
    import('../../pages/manager/TeamDirectoryPage').then((module) => ({ default: module.TeamDirectoryPage })),
)

// Performance Upload components (renamed from manager-uploads)
const LazyPerformanceDataManagementPage = React.lazy(() =>
    import('../../pages/manager/Uploads/upload').then((module) => ({ default: module.DataManagementPage })),
)

// Shared components for managers
const LazyEmployeeDetailPage = React.lazy(() =>
    import('../../pages/shared/EmployeeDetailPage').then((module) => ({ default: module.EmployeeDetailPage })),
)

// Manager Learn components
const LazyManagerLearnPage = React.lazy(() =>
    import('../../pages/manager/Learn').then((module) => ({ default: module.LearnPage })),
)

export const managerRoutes: RouteConfig[] = [
    // Team management routes
    {
        path: AppRoutes.TEAM,
        component: LazyTeamDirectoryPage,
        layout: LayoutType.APP,
        requireAuth: true,
        requireOrganization: true,
        title: 'Team Directory',
        description: 'View and manage your team members',
        requiredPermission: {
            action: 'view.team', // Matches employee.view.team permission
            subject: 'Employee',
        },
    },
    {
        path: AppRoutes.TEAM_MEMBER_DETAIL,
        component: LazyEmployeeDetailPage,
        layout: LayoutType.APP,
        requireAuth: true,
        requireOrganization: true,
        title: 'Team Member Profile',
        description: 'View detailed team member profile',
        requiredPermission: {
            action: 'view.team', // Matches employee.view.team permission
            subject: 'Employee',
        },
    },

    // Performance Upload routes (unified structure)
    {
        path: AppRoutes.UPLOAD_PERFORMANCE,
        component: LazyPerformanceDataManagementPage,
        layout: LayoutType.APP,
        requireAuth: true,
        requireOrganization: true,
        title: 'Performance Upload',
        description: 'Upload and manage performance data and files',
        requiredPermission: {
            action: 'manage.documents', // Matches employee.manage.documents permission
            subject: 'Employee',
        },
    },

    // Manager Learn routes - these need to come AFTER the shared /learn route to avoid conflicts
    {
        path: AppRoutes.LEARN_SECTION,
        component: LazyManagerLearnPage,
        layout: LayoutType.APP,
        requireAuth: true,
        requireOrganization: true,
        allowedRoles: ['people_manager'],
        title: 'Learn - Class Details',
        description: 'View learning class details and videos',
        requiredPermission: {
            action: 'view',
            subject: 'Dashboard',
        },
    },
]
